import React from "react";
import {Link} from 'react-router-dom';

class Login extends React.Component {
    render() {
        return (
            <main className="o-page-wrap  o-page-wrap--small">
                <div className="o-page-wrap">
                    <nav>
                        <ul className="c-breadcrumb">
                            <li>
                                <Link to="/"><i aria-hidden="true" className="c-icon c-icon--[house]"></i></Link>
                            </li>
                            <li><span>License Notifications</span></li>
                        </ul>
                    </nav>
                </div>

                <div className="c-hero-teaser c-hero-teaser--no-image c-hero-teaser--auto">
                    <div id="js-hero-teaser-content" className="c-hero-teaser__content">
                        <div className="o-page-wrap">
                            <header className="c-hero-teaser__heading">
                                <div className="c-hero-teaser__title">
                                    <h1>
                                        <span className="c-hero-teaser__title-row">License Notifications</span><br/>
                                    </h1>
                                </div>
                                <div className="c-hero-teaser__subtitle">
                                    <div>The following components of third parties are used on this website:
                                    </div>
                                </div>
                            </header>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <section className="js-content-section o-content-section ">
                        <div className="o-page-wrap">
                            <div className="o-component-wrapper">
                                <header className="u-text-center u-mb-large o-page-wrap o-page-wrap--xsmall">
                                    <h3>
                                        <p>MIT-License</p>
                                    </h3>
                                </header>
                                <div className="c-table-wrapper o-page-wrap">
                                    <table width="100%" cellSpacing="0" cellPadding="1" border="0">
                                        <tbody>
                                        <tr>
                                            <th className="c-table__cell--highlight"><b>Name</b></th>
                                            <th className="c-table__cell--highlight"><b>Version</b></th>
                                            <th className="c-table__cell--highlight"><b>Copyright</b></th>
                                        </tr>
                                        <tr>
                                            <td>Flatpickr</td>
                                            <td>2.6.1</td>
                                            <td>Copyright (c) 2017 Gregory Petrosyan<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Plyr.js</td>
                                            <td>2.0.11</td>
                                            <td>Copyright (c) 2017 Sam Potts<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Smooth-scroll</td>
                                            <td>11.1.0</td>
                                            <td>Copyright (c) Go Make Things, LLC<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Sticky-JS</td>
                                            <td>1.2.0</td>
                                            <td>Copyright (c) 2016 Rafał Gałus<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Object-Fit-Images</td>
                                            <td>3.1.3</td>
                                            <td>Copyright (c) Federico Brigante<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Moment.js</td>
                                            <td>2.18.1</td>
                                            <td>Copyright (c) JS Foundation and other contributors<br/></td>
                                        </tr>
                                        <tr>
                                            <td>Waypoints</td>
                                            <td>4.0.1</td>
                                            <td>Copyright (c) 2011-2016 Caleb Troughton</td>
                                        </tr>
                                        <tr>
                                            <td>Chart.js</td>
                                            <td>2.7.3</td>
                                            <td>Copyright (c) 2018 Chart.js Contributors</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        <div className="o-page-wrap o-page-wrap--small">
                            <div className="o-component-wrapper">
                                <p>Permission is hereby granted, free of charge, to any person obtaining a copy of this
                                    software
                                    and
                                    associated documentation files (the &quot;Software&quot;), to deal in the Software
                                    without
                                    restriction, including without limitation the rights to use, copy, modify, merge,
                                    publish,
                                    distribute, sublicense, and/or sell copies of the Software, and to permit persons to
                                    whom
                                    the
                                    Software is furnished to do so, subject to the following conditions:The above
                                    copyright
                                    notice
                                    and this permission notice shall be included in all copies or substantial portions
                                    of the
                                    Software.<br/>
                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED,
                                    INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                    PARTICULAR
                                    PURPOSE
                                    AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE
                                    FOR ANY
                                    CLAIM,
                                    DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
                                    ARISING
                                    FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        );
    }
}

export default Login